module.exports = __webpack_public_path__ + "static/media/loading.59468b54.svg";